/**
 * Helper function that will return a JSON file and check its integrity.
 *
 * @param src - The JSON src
 * @param integrityHash - The integrity hash to check whether the json file has changed.
 * @returns {Promise<any | {error: any}>}
 */
export default function fetchJSON(src, integrityHash) {
  return fetch(src, {
    integrity: integrityHash
  })
    .then (response => response.json())
    .catch (error => { return { error }});
}
